app.controller('DiscoveryCtrl', function ($scope, $q, $window, $filter, DiscoveryService, FlashMessageService) {

    var self = this;

    // perform a non-textual search based on discovery's suggested concepts
    self.explore = function (discoveryConcepts) {
        $scope.searchData.terms = null;
        $scope.searchData.discoveryConcepts = discoveryConcepts;

        // track Piwik Analytics Goal 1 : Discovery
        if (window._paq) window._paq.push(['trackGoal', 1]);

        $scope.search($scope.searchData);
    };

    // launch Discovery queries after we receive concepts
    $scope.$on('conceptListPromiseSuccessful', function () {

        if ($scope.concepts.originalConcepts.length) {
            self.loading = true;

            $q.all([
                DiscoveryService.listRelated($scope.searchData.searchProfileId, $scope.searchData.collections, $scope.searchData.precision,
                    $scope.searchData.dateFrom, $scope.searchData.dateTo, $scope.concepts.originalConcepts).then(function (relatedConcepts) {
                    self.relatedConcepts = relatedConcepts;
                }),
                DiscoveryService.listNonRelated($scope.searchData.searchProfileId, $scope.searchData.collections, $scope.searchData.precision,
                    $scope.searchData.dateFrom, $scope.searchData.dateTo, $scope.suggestedConcepts, $scope.concepts.originalConcepts).then(function (nonRelatedConcepts) {
                    self.nonRelatedConcepts = nonRelatedConcepts;
                }),
                DiscoveryService.listNeighbours($scope.searchData.searchProfileId, $scope.searchData.collections, $scope.searchData.precision,
                    $scope.searchData.dateFrom, $scope.searchData.dateTo, $scope.concepts.originalConcepts).then(function (neighbourConcepts) {
                    self.neighbourConcepts = neighbourConcepts;
                })
            ]).then(function () {
                self.loading = false;
            }, function (error) {
                self.loading = false;
                if (typeof error.message !== 'undefined' && typeof error.message.title !== 'undefined') {
                    FlashMessageService.show(error.message.title, 'error');
                } else {
                    FlashMessageService.show($filter('translate')('messages.generalError'), 'error');
                }
            });
        } else {
            $scope.noDiscovery = true;
        }
    });

    // reset data on search
    $scope.$on('search', function () {
        self.relatedConcepts = [];
        self.nonRelatedConcepts = [];
        self.neighbourConcepts = [];
        $scope.noDiscovery = false;
    });
});
